import { useDictationStore } from '@/features/dictation/dictationBubble/store/useDictationStore';
import type { MouseEvent } from 'react';
import { useCallback } from 'react';

/**
 * Shared hook for handling close actions on dictation bubble components.
 * Stops event propagation and resets the dictation store state.
 */
export const useDictationClose = () => {
  const reset = useDictationStore((s) => s.reset);

  const handleClose = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      reset();
    },
    [reset]
  );

  return { handleClose, reset };
};
